import React from 'react';

import { Radio } from '@infoods/lifebase-ui';

import classes from './SubscriptionCell.module.scss';
import { SelectableCard } from '../../../../../../shared/components/form-components';

type SubscriptionCellProps = {
  name: string;
  subscriptionId: number;
};

const SubscriptionCell = ({ name, subscriptionId }: SubscriptionCellProps) => {
  return (
    <SelectableCard variant="inBox" className={classes.cell}>
      <Radio value={subscriptionId} />
      <p className={classes.name}>{name}</p>
    </SelectableCard>
  );
};

export { SubscriptionCell };
